import { render } from "./EventReportTab.vue?vue&type=template&id=31fbfe4f&scoped=true"
import script from "./EventReportTab.vue?vue&type=script&lang=js"
export * from "./EventReportTab.vue?vue&type=script&lang=js"

import "./EventReportTab.vue?vue&type=style&index=0&id=31fbfe4f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fbfe4f"]])

export default __exports__